import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import styled from 'styled-components';
import Code from 'UIComponents/elements/Code';
import UIBadge from 'UIComponents/badge/UIBadge';
import UITruncateString from 'UIComponents/text/UITruncateString';
import { THUNDERDOME_DARK, LORAX_DARK, OZ_DARK, CANDY_APPLE_DARK } from 'HubStyleTokens/colors';
import { WEB_FONT_BOLD_WEIGHT } from 'HubStyleTokens/misc';
const StyledMethod = styled(UIBadge).withConfig({
  displayName: "EndpointComp__StyledMethod",
  componentId: "sc-1n0rxnn-0"
})(["border-radius:20px;padding:0 11px;&.get{background-color:", ";}&.post{background-color:", ";}&.delete{background-color:", ";}&.put,&.patch{background-color:", ";}"], THUNDERDOME_DARK, OZ_DARK, CANDY_APPLE_DARK, LORAX_DARK);
const StyledCode = styled(Code).withConfig({
  displayName: "EndpointComp__StyledCode",
  componentId: "sc-1n0rxnn-1"
})(["background-color:transparent;padding:0 12px 4px 12px;"]);
const StyledPath = styled.span.withConfig({
  displayName: "EndpointComp__StyledPath",
  componentId: "sc-1n0rxnn-2"
})(["font-weight:", ";"], WEB_FONT_BOLD_WEIGHT);

const Endpoint = ({
  method,
  path
}) => {
  return /*#__PURE__*/_jsxs("div", {
    className: "flex-no-wrap align-center",
    children: [/*#__PURE__*/_jsx(StyledMethod, {
      className: method,
      children: method
    }), /*#__PURE__*/_jsx(StyledCode, {
      children: /*#__PURE__*/_jsx(StyledPath, {
        children: /*#__PURE__*/_jsx(UITruncateString, {
          reverse: true,
          children: path
        })
      })
    })]
  });
};

export default Endpoint;